import React, { useState } from 'react';
import { Button } from '../../../../../shared/components';
import { customDateStr } from '../../../../../shared/misc/utils';
import DetailsCell from './DetailsCell';
import { FlowComment } from '../../../../../services/types/Flow';

interface Props {
  data: FlowComment;
  flowType: string;
  hideExpander?: boolean;
}

const CommentRow: React.FC<Props> = (props) => {
  const { data: row, flowType, hideExpander } = props;
  const [rowExpanded, setRowExpanded] = useState(false);

  const showExpander = !hideExpander && row.description.length > 250;
  const desc =
    !rowExpanded && showExpander ? `${row.description.substr(0, 250)}...` : row.description;

  const chevron = rowExpanded ? 'chevron-down' : 'chevron-right';
  const renderTypes = () => row.types.map((x, i) => <li key={`types_${i.toString()}`}>{x}</li>);

  return (
    <tr>
      {!hideExpander && (
        <td style={{ width: '55px' }}>
          {showExpander && (
            <Button
              className="btn-tertiary py-0 px-1"
              icon={chevron}
              text=""
              type="button"
              onClick={() => setRowExpanded((current) => !current)}
            />
          )}
        </td>
      )}

      <td style={{ width: '200px' }}>
        <DetailsCell
          author={row.author}
          version={row.version}
          lap={row.lap}
          topic={row.topic}
          keywords={row.keywords}
          flowType={flowType}
        />
      </td>
      <td>
        <div className="flow-description-cell">{desc}</div>
      </td>
      <td className="text-right">
        <p>
          <span className="w-100">{customDateStr(row.date)}</span>
        </p>
        <ul>{renderTypes()}</ul>
      </td>
    </tr>
  );
};

export default CommentRow;
